import React, { createContext, useState, } from 'react';
export var OrderContext = createContext({
    currentDrawer: '',
    setCurrentDrawer: function () { return null; },
    showDrawerError: null,
    setShowDrawerError: function () { return null; },
    showReasonCodesApiError: {},
    setReasonCodesApiError: function () { return null; },
    cancellationReasonCodes: [],
    setCancellationReasonCodes: function () { return null; },
    deliveryAddresses: [],
    setDeliveryAddresses: function () { return null; },
    showDeliveryAddressesApiError: {},
    setDeliveryAddressesApiError: function () { return null; },
    availableDeliverySlotsResponse: null,
    setAvailableDeliverySlotsResponse: function () { return null; },
    showDeliveryAvailableSlotsApiError: {},
    setDeliveryAvailableSlotsApiError: function () { return null; },
    deliveryInstructions: null,
    setDeliveryInstructions: function () { return null; },
    requireSignature: false,
    setRequireSignature: function () { return null; },
    selectedDateId: null,
    setSelectedDateId: function () { return null; },
    availableDeliverySlots: [],
    setAvailableDeliverySlots: function () { return null; },
    showCalendar: false,
    setShowCalendar: function () { return null; },
    selectedDeliverySlot: null,
    setSelectedDeliverySlot: function () { return null; },
    deliveryDate: '',
    setDeliveryDate: function () { return null; },
    orderDetailsData: {},
    setOrderDetailsData: function () { return null; },
    orderId: '',
    setOrderId: function () { return undefined; },
    customerType: undefined,
    setCustomerType: function () { return undefined; },
});
export var OrderProvider = function (_a) {
    var children = _a.children;
    var _b = useState(''), currentDrawer = _b[0], setCurrentDrawer = _b[1];
    var _c = useState(null), showDrawerError = _c[0], setShowDrawerError = _c[1];
    var _d = useState({}), showReasonCodesApiError = _d[0], setReasonCodesApiError = _d[1];
    var _e = useState([]), cancellationReasonCodes = _e[0], setCancellationReasonCodes = _e[1];
    var _f = useState([]), deliveryAddresses = _f[0], setDeliveryAddresses = _f[1];
    var _g = useState({}), showDeliveryAddressesApiError = _g[0], setDeliveryAddressesApiError = _g[1];
    var _h = useState(null), availableDeliverySlotsResponse = _h[0], setAvailableDeliverySlotsResponse = _h[1];
    var _j = useState({}), showDeliveryAvailableSlotsApiError = _j[0], setDeliveryAvailableSlotsApiError = _j[1];
    var _k = useState(null), deliveryInstructions = _k[0], setDeliveryInstructions = _k[1];
    var _l = useState(false), requireSignature = _l[0], setRequireSignature = _l[1];
    var _m = useState([]), availableDeliverySlots = _m[0], setAvailableDeliverySlots = _m[1];
    var _o = useState(null), selectedDateId = _o[0], setSelectedDateId = _o[1];
    var _p = useState(false), showCalendar = _p[0], setShowCalendar = _p[1];
    var _q = useState(null), selectedDeliverySlot = _q[0], setSelectedDeliverySlot = _q[1];
    var _r = useState(''), deliveryDate = _r[0], setDeliveryDate = _r[1];
    var _s = useState({}), orderDetailsData = _s[0], setOrderDetailsData = _s[1];
    var _t = useState(undefined), orderId = _t[0], setOrderId = _t[1];
    var _u = useState(undefined), customerType = _u[0], setCustomerType = _u[1];
    return (React.createElement(OrderContext.Provider, { value: {
            currentDrawer: currentDrawer,
            setCurrentDrawer: setCurrentDrawer,
            showDrawerError: showDrawerError,
            setShowDrawerError: setShowDrawerError,
            showReasonCodesApiError: showReasonCodesApiError,
            setReasonCodesApiError: setReasonCodesApiError,
            cancellationReasonCodes: cancellationReasonCodes,
            setCancellationReasonCodes: setCancellationReasonCodes,
            deliveryAddresses: deliveryAddresses,
            setDeliveryAddresses: setDeliveryAddresses,
            showDeliveryAddressesApiError: showDeliveryAddressesApiError,
            setDeliveryAddressesApiError: setDeliveryAddressesApiError,
            availableDeliverySlotsResponse: availableDeliverySlotsResponse,
            setAvailableDeliverySlotsResponse: setAvailableDeliverySlotsResponse,
            showDeliveryAvailableSlotsApiError: showDeliveryAvailableSlotsApiError,
            setDeliveryAvailableSlotsApiError: setDeliveryAvailableSlotsApiError,
            deliveryInstructions: deliveryInstructions,
            setDeliveryInstructions: setDeliveryInstructions,
            requireSignature: requireSignature,
            setRequireSignature: setRequireSignature,
            selectedDateId: selectedDateId,
            setSelectedDateId: setSelectedDateId,
            availableDeliverySlots: availableDeliverySlots,
            setAvailableDeliverySlots: setAvailableDeliverySlots,
            showCalendar: showCalendar,
            setShowCalendar: setShowCalendar,
            selectedDeliverySlot: selectedDeliverySlot,
            setSelectedDeliverySlot: setSelectedDeliverySlot,
            deliveryDate: deliveryDate,
            setDeliveryDate: setDeliveryDate,
            orderDetailsData: orderDetailsData,
            setOrderDetailsData: setOrderDetailsData,
            orderId: orderId,
            setOrderId: setOrderId,
            customerType: customerType,
            setCustomerType: setCustomerType,
        } }, children));
};
